export function PortalFooter() {
  return (
    <footer className="border-t bg-card">
      <div className="text-muted-foreground mx-auto flex w-full max-w-5xl flex-col gap-1 px-4 py-4 text-xs sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <span>© {new Date().getFullYear()} USA Restaurant Suppliers</span>
        <span>Need help? Reach out to your sales contact above.</span>
      </div>
    </footer>
  )
}
